// extracted by mini-css-extract-plugin
export var locationCard = "_go-0";